//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {shareImg, savePhoto, logEventStatistics} from '@/util/const'

export default {
    name: "openScreen",
    data() {
        return {
            state: 0,
            img: '',
            lang: '',
            showMask: false
        }
    },
    methods: {
        get() {
            this.$http.get('/v1/api/ad/festival/isFestival').then(res => {
                if (res.data.header.resultCode === 0) {
                    if (!res.data.body.isFestival) {
                        this.state = 1
                    } else {
                        let img = ''
                        if (this.lang === 'sc') img = res.data.body.festivalInfo.imgSc
                        if (this.lang === 'tc') img = res.data.body.festivalInfo.imgTc
                        if (this.lang === 'en') img = res.data.body.festivalInfo.imgEn
                        this.img = img
                        this.state = 2
                        if(res.data.body.festivalInfo.carouselUmkey){
                            logEventStatistics({
                                umkey: res.data.body.festivalInfo.carouselUmkey
                            })
                        }
                    }
                }
            })
        },
        share() {
            let href = `${location.origin}${location.pathname}#/openScreen`
            let title = `${this.$t('activity5G.openScreen.title')}`
            let content = `${this.$t('activity5G.openScreen.content')}`
            let url = `cmcchkhsh://openshare?url=${encodeURIComponent(href)}&title=${title}&content=${content}&img=${this.img}&type=`
            window.location.href = url
        },
        shareFnc() {
            shareImg({"platform": '', "imgUrl": this.img})
        },
        savePic() {
          savePhoto({ imgUrl: this.img, callback: 'savePhoto' })
        }
    },
    created() {
        this.lang = window.localStorage.lang
        this.get()
      window.savePhoto = (obj) => {
        this.$toast({ msg: this.$t('activity5G.openScreen.c3'), time: 1000 })
      }
    }
}



// WEBPACK FOOTER //
// ./src/page/openScreen/openScreen.vue